import { Navigate } from "react-router-dom";

function VolunteerProtected({ children }) {
  return sessionStorage.getItem("volunteerData")
    ? children
    : <Navigate to="/volunteer/login" replace />;
}

export default VolunteerProtected;
